import { Link, useNavigate, useLocation } from "react-router-dom";
import { MapPin, PawPrint, Star } from "lucide-react";
import { useEffect, useState } from "react";
import Logo from "./Logo";
import api from "../lib/api";

const FooterReviewLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const go = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.querySelector("#reviews")?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.querySelector("#reviews")?.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <button
      onClick={go}
      data-testid="footer-review-link"
      className="mt-6 inline-flex items-center gap-2 rounded-full border border-ink/15 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-ink transition-colors duration-200 hover:bg-sand"
    >
      <PawPrint className="h-3.5 w-3.5 text-marmalade" />
      Leave a review
    </button>
  );
};

const Footer = () => {
  const [area, setArea] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/service-area`)
      .then((r) => r.json())
      .then((d) => setArea(d))
      .catch(() => setArea(null));
  }, []);

  return (
  <footer className="border-t border-line bg-cream">
    <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-12 md:py-20">
      <div className="flex flex-col gap-12 md:flex-row md:justify-between">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-6 text-sm leading-relaxed text-inkSoft">
            Overnight house sitting, boarding, walks and drop-in visits — from Ari, your one-and-only sitter.
          </p>
          {area?.enabled && area.base_label && (
            <p className="mt-3 flex items-center gap-2 text-sm text-forest" data-testid="footer-service-area">
              <MapPin className="h-4 w-4 shrink-0" />
              Proudly serving {area.base_label} + {area.radius_miles} miles
            </p>
          )}
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-marmalade">Services</p>
          <ul className="mt-5 space-y-3 text-sm text-ink">
            <li>Overnight house sitting</li>
            <li>Boarding in Ari's home</li>
            <li>Dog walking</li>
            <li>Drop-in visits</li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-marmalade">Say hello</p>
          <ul className="mt-5 space-y-3 text-sm text-ink">
            <li>
              <a
                href="mailto:gonzalezarii31@icloud.com"
                data-testid="footer-email-link"
                className="transition-[color] duration-200 hover:text-marmalade"
              >
                gonzalezarii31@icloud.com
              </a>
            </li>
            <li>Every day, 8am – 8pm</li>
          </ul>
          <FooterReviewLink />
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-4 border-t border-line pt-8 text-xs text-inkSoft md:flex-row md:items-center md:justify-between">
        <p className="flex items-center gap-2">
          <PawPrint className="h-3.5 w-3.5 text-marmalade" />
          © {new Date().getFullYear()} Ari's Happy Tails. All rights reserved.
        </p>
        <Link
          to="/admin"
          data-testid="footer-sitter-login"
          className="font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-200 hover:text-marmalade"
        >
          Sitter login
        </Link>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
